<div class="h-full min-w-0 w-full flex flex-col justify-start items-center overflow-hidden space-y-4">
    <div
        class="h-full min-w-0 flex flex-col gap-4 items-stretch justify-start w-full overflow-y-auto overflow-x-hidden scrollbar-transparent">
        <!-- Greeting -->
        <div class="flex w-full min-w-0 flex-col items-start justify-between gap-3 sm:flex-row sm:items-center">
            <div class="min-w-0 flex-1 flex flex-col gap-y-2">
                @if (currentUserService.shoutUser$ | async; as shoutUser) {
                <h2
                    class="text-2xl font-semibold tracking-tight text-balance text-primary sm:text-3xl md:text-4xl text-left use-grotesque">
                    Hey,
                    <span class="bg-gradient-to-r from-primary to-brand-studio bg-clip-text text-transparent">{{
                        shoutUser?.firstName }}</span> 👋
                </h2>
                }
                <p class="text-sm text-secondary">Here's what's happened since you last checked in. 🎉</p>
            </div>
            <div class="shrink-0">
                @if (lastVisit() && lastVisit() !== null) {
                <p
                    class="m-0 inline-flex items-center gap-x-1.5 rounded-full px-2 py-1 text-xs font-medium text-gray-900 inset-ring inset-ring-gray-200 sm:text-sm dark:text-gray-200 dark:inset-ring-white/10">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="size-5 text-primary" aria-hidden="true">
                        <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
                        <path d="M3 3v5h5" />
                        <path d="M12 7v5l4 2" />
                    </svg>
                    Last visit: {{ lastVisit() | date:'dd MMM, HH:mm' }}
                </p>
                }
            </div>
        </div>
        <!-- Greeting - END -->

        <!-- Top Stats Row -->
        <dbv2-top-stats-row class="w-full min-w-0"></dbv2-top-stats-row>
        <!-- Top Stats Row - END -->

        <!-- Latest briefs, Recent Activity, New Brief & Un-read Messages -->
        <div class="w-full min-w-0 grid grid-cols-1 gap-4 lg:grid-cols-4 lg:items-stretch">
            <div class="contents lg:col-span-3 lg:flex lg:h-full lg:min-h-0 lg:flex-col lg:gap-4">
                <!-- Latest Briefs -->
                <dbv2-latest-briefs class="order-2 min-w-0 w-full lg:order-none"></dbv2-latest-briefs>
                <!-- Latest Briefs - END -->

                <!-- Un-Read Messages -->
                <dbv2-unread-messages class="order-3 min-w-0 w-full lg:order-none"></dbv2-unread-messages>
                <!-- Un-Read Messages - END -->
            </div>

            <div class="contents lg:flex lg:h-196 lg:min-h-0 lg:flex-col lg:gap-4">
                <!-- New Brief -->
                <div
                    class="order-1 min-w-0 w-full shrink-0 flex flex-col divide-y divide-gray-100 dark:divide-white/10 overflow-hidden shadow-card-container-pale lg:order-none">
                    <div class="shrink-0 p-2 flex flex-row flex-wrap items-center justify-between gap-2">
                        <div class="flex min-w-0 items-center flex-1">
                            <div class="shrink-0">
                                <div
                                    class="size-10 rounded-xl bg-primary/20 text-accent text-sm font-semibold flex items-center justify-center">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" class="size-6" aria-hidden="true">
                                        <path d="M5 12h14" />
                                        <path d="M12 5v14" />
                                    </svg>
                                </div>
                            </div>
                            <div class="ml-4 min-w-0">
                                <h3 class="text-md font-semibold text-primary">Create New Brief</h3>
                            </div>
                        </div>
                    </div>

                    <div class="flex flex-col gap-4 p-2">
                        <p class="text-sm text-secondary">
                            Launch a UGC campaign in seconds — AI drafts the concept, requirements and creative
                            angles for you.
                        </p>

                        <div class="w-full flex flex-row items-center justify-center gap-x-4">
                            <button [routerLink]="['/create-brief-select']" type="button"
                                class="inline-flex w-full items-center justify-center gap-x-1.5 flashy-go-button sm:w-3/4">
                                Create Brief
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="size-5" aria-hidden="true">
                                    <path d="M5 12h14" />
                                    <path d="m12 5 7 7-7 7" />
                                </svg>
                            </button>
                            <button *appHasRole="[77]" [routerLink]="['/create-brief-select-smart']" type="button" class="btn-fab-flashy-go">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="size-6">
                                    <path
                                        d="M15.39 4.39a1 1 0 0 0 1.68-.474 2.5 2.5 0 1 1 3.014 3.015 1 1 0 0 0-.474 1.68l1.683 1.682a2.414 2.414 0 0 1 0 3.414L19.61 15.39a1 1 0 0 1-1.68-.474 2.5 2.5 0 1 0-3.014 3.015 1 1 0 0 1 .474 1.68l-1.683 1.682a2.414 2.414 0 0 1-3.414 0L8.61 19.61a1 1 0 0 0-1.68.474 2.5 2.5 0 1 1-3.014-3.015 1 1 0 0 0 .474-1.68l-1.683-1.682a2.414 2.414 0 0 1 0-3.414L4.39 8.61a1 1 0 0 1 1.68.474 2.5 2.5 0 1 0 3.014-3.015 1 1 0 0 1-.474-1.68l1.683-1.682a2.414 2.414 0 0 1 3.414 0z" />
                                </svg>
                            </button>

                        </div>
                    </div>
                </div>
                <!-- New Brief - END -->

                <!-- Recent Activity -->
                <dbv2-recent-activity
                    class="order-4 h-96 min-h-96 w-full min-w-0 overflow-hidden lg:order-none lg:h-0 lg:min-h-0 lg:flex-1"></dbv2-recent-activity>
                <!-- Recent Activity - END -->
            </div>
        </div>
        <!-- Latest briefs, Recent Activity, New Brief & Un-read Messages - END -->

        <!-- Videos to Review -->
        <dbv2-videos-to-review class="w-full min-w-0 col-span-full"></dbv2-videos-to-review>
        <!-- Videos to Review - END -->

        <!-- Creators Interested in You -->
        <dbv2-interested-creators class="w-full min-w-0"></dbv2-interested-creators>
        <!-- Creators Interested in You - END -->

        <div class="flex items-center justify-center w-full p-2">
            <p class="m-0 text-sm text-secondary">Version: {{ appVersion }}</p>
        </div>
    </div>
</div>